import React, { useState } from 'react';

import { Box, IconButton, Input } from '@mui/joy';

import MenuIcon from './icons/MenuIcon.svg?react';
import NewMissionIcon from './icons/NewMissionIcon.svg?react';
import OpenMissionIcon from './icons/OpenMissionIcon.svg?react';
import SaveMissionIcon from './icons/SaveMissionIcon.svg?react';
import MissionSavedModal from './MissionSavedModal';

interface TopBarProps {
  onMenuClick?: () => void;
  onNewMissionClick?: () => void;
  onOpenMissionClick?: () => void;
  onSaveMissionClick?: () => Promise<void>;
  missionName?: string;
  onMissionNameChange?: (missionName: string) => void;
  saveEnabled: boolean;
}

const TopBar: React.FC<TopBarProps> = ({
  onMenuClick,
  onNewMissionClick,
  onOpenMissionClick,
  onSaveMissionClick,
  missionName,
  onMissionNameChange,
  saveEnabled
}) => {
  const [showSavedModal, setShowSavedModal] = useState(false);

  const handleSaveClick = async () => {
    if (onSaveMissionClick) {
      try {
        await onSaveMissionClick();
        setShowSavedModal(true);
      } catch (error) {
        console.error('Failed to save mission:', error);
      }
    }
  };
  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        height: '60px',
        backgroundColor: 'neutral.900',
        justifyContent: 'space-between',
        zIndex: 3,
        paddingX: 1
      }}
    >
      {/* Left side of menu bar */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1
        }}
      >
        <IconButton
          variant='plain'
          size='lg'
          onClick={onMenuClick}
          sx={{
            color: 'neutral.300',
            '&:hover': {
              backgroundColor: 'neutral.800',
              color: '#F0F4F8'
            }
          }}
        >
          <MenuIcon fill='#F0F4F8' stroke='#F0F4F8' strokeWidth='1' />
        </IconButton>
        <IconButton
          variant='plain'
          size='lg'
          onClick={onNewMissionClick}
          sx={{
            color: 'neutral.300',
            '&:hover': {
              backgroundColor: 'neutral.800',
              color: '#F0F4F8'
            }
          }}
        >
          <NewMissionIcon fill='#F0F4F8' stroke='#F0F4F8' strokeWidth='1' />
        </IconButton>
        <IconButton
          variant='plain'
          size='lg'
          onClick={onOpenMissionClick}
          sx={{
            color: 'neutral.300',
            '&:hover': {
              backgroundColor: 'neutral.800',
              color: '#F0F4F8'
            }
          }}
        >
          <OpenMissionIcon fill='#F0F4F8' stroke='#F0F4F8' strokeWidth='1' />
        </IconButton>
      </Box>

      {/* Center of menu bar */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1
        }}
      >
        <Input
          value={missionName}
          onChange={(e) => onMissionNameChange?.(e.target.value)}
          placeholder='Mission Name'
          sx={{
            backgroundColor: 'transparent',
            border: 'none',
            color: 'neutral.100',
            minWidth: '200px',
            '& input': {
              color: 'neutral.100',
              '&::placeholder': {
                color: 'neutral.400'
              }
            }
          }}
        />
        <IconButton
          variant='plain'
          size='lg'
          onClick={handleSaveClick}
          sx={{
            color: 'neutral.300',
            '&:hover': {
              backgroundColor: 'neutral.800',
              color: '#F0F4F8'
            },
            '&:disabled': {
              color: 'neutral.600',
              '& svg': {
                fill: 'neutral.600',
                stroke: 'neutral.600'
              }
            }
          }}
          disabled={!saveEnabled}
        >
          <SaveMissionIcon
            fill={saveEnabled ? '#F0F4F8' : 'currentColor'}
            stroke={saveEnabled ? '#F0F4F8' : 'currentColor'}
            strokeWidth='1'
          />
        </IconButton>
      </Box>

      {/* Right side of menu bar */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1
        }}
      >
        {/*  */}
      </Box>

      <MissionSavedModal open={showSavedModal} onClose={() => setShowSavedModal(false)} missionName={missionName} />
    </Box>
  );
};

export default TopBar;
